export const Spinner = () => {
  return (
    <div className="loading-spinner"></div>
  );
};